import gql from 'graphql-tag';
import LeadFragments from '../fragments/lead.fragments';

const LIST_LEADS = gql`
  query Leads($params: ListLeadsParams!) {
    leads(params: $params) {
      ...LeadFields
      ...LeadLoiFiles
      ...LeadOffers
      ...LeadFileAccessLevel
      ...LeadPrivateListingAccess
      ...LeadNotes
      ...LeadSellerNotes
      ...LeadUser
      ...LeadListing
      ...LeadMetrics
      ...LeadMeta
      ...LeadAnalyticsEvents
      ...LeadChannel
    }
  }

  ${LeadFragments.fields}
  ${LeadFragments.loiFiles}
  ${LeadFragments.loiFiles}
  ${LeadFragments.offers}
  ${LeadFragments.fileAccessLevel}
  ${LeadFragments.privateListingAccess}
  ${LeadFragments.notes}
  ${LeadFragments.sellerNotes}
  ${LeadFragments.user}
  ${LeadFragments.listing}
  ${LeadFragments.metrics}
  ${LeadFragments.meta}
  ${LeadFragments.analyticsEvents}
  ${LeadFragments.channel}
`;

export default LIST_LEADS;
